import { Injectable } from '@angular/core';
import LocalStorage from '@app/helpers/LocalStorage';
import SessionStorage from '@app/helpers/SessionStorage';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {

  constructor() { }


  setHotel3pId(value: string) {
    localStorage.setItem("hotel3pid", value)
  }

  getHotel3pId(): string {
    return localStorage.getItem('hotel3pid')
  }

  setDeviceId(value: string) {
    localStorage.setItem("deviceId", value)
  }

  getDeviceId(): string {
    return localStorage.getItem('deviceId')
  }


 setGroup3Pid(value: string) {
    LocalStorage.Group3Pid = value
    
 }

  getGroup3Pid(): string {
    return LocalStorage.Group3Pid;
  }

 
  setOperationMode(value: string) {
    LocalStorage.OperationMode = value
    
 }

  getOperationMode(): string {
    return LocalStorage.OperationMode;
  }



  public static set IsTabletMode( tabletMode: boolean) {
    sessionStorage.setItem("ist",tabletMode ? "Y" : "N" )
  }

  public static get PhotoInTabletMode(): boolean {
    return sessionStorage.getItem("pit") == "Y" ? true : false
  }


  // setSubscriber(value: string) {
  //   localStorage.setItem("subscriber", value)
  // }
  // getSubscriber(): string {
  //   return localStorage.getItem('subscriber')
  // }


  // setHotelId(value: string) {
  //   localStorage.setItem("hotelId", value)
  // }
  // getHotelId(): string {
  //   return localStorage.getItem('hotelId')
  // }

}